<template>
  <div>
    <PreviewLayout :item="item" :loading="loading">
      <span class="p-postEditor__text" v-html="previewContent(content)"></span>
    </PreviewLayout>
  </div>
</template>

<script>
import PreviewLayout from './PreviewLayout'
import baseTextlintPreview from '@/mixins/base_textlint_preview'

export default {
  name: 'TextItemPreview',
  components: { PreviewLayout },
  mixins: [baseTextlintPreview],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    content: function () {
      return this.item.itemableAttributes.content
    }
  },
  mounted () {
    this.setLintAction(this.content)

    this.$store.subscribe((mutation) => {
      if (mutation.type === 'PostEditor/UPDATE_ITEM') {
        if (mutation.payload.uuid === this.item.uuid) {
          this.setLintAction(this.content)
          this.$store.commit('TextLintStore/deleteItemLintResult', {
            uuid: this.uuid
          })
          this.lintAction().call()
        }
      }
    })
  }
}
</script>
